var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":_vm.url}},[(_vm.img)?_c('img',{staticClass:"ad-image",attrs:{"src":_vm.img}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }